<template>
    <div :class="`flex justify-center items-center wrapper rating-size-${size}`">
        <div>
            <div class="star-ratings-empty">
                <span class="icon icon-star-full"></span><span class="icon icon-star-full"></span
                ><span class="icon icon-star-full"></span><span class="icon icon-star-full"></span
                ><span class="icon icon-star-full"></span>
            </div>
            <div
                class="star-ratings-full"
                :style="{ width: starRating + '%' }"
            >
                <span class="icon icon-star-full"></span><span class="icon icon-star-full"></span
                ><span class="icon icon-star-full"></span><span class="icon icon-star-full"></span
                ><span class="icon icon-star-full"></span>
            </div>
        </div>

        <span class="rate">{{ outOfFiveRating }}</span>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'StarRating',
    props: {
        starRating: {
            type: Number,
            required: true,
            default: 100,
            validator(rating) {
                return rating >= 0 && rating <= 100;
            },
        },
        size: {
            type: String,
            required: false,
            default: 'normal',
            validator(size) {
                // The value must match one of these strings
                return ['normal', 'small'].indexOf(size) !== -1;
            },
        },
    },
    computed: {
        ...mapGetters('ui', ['getLocale']),
        outOfFiveRating() {
            const rating = this.starRating / 20;
            return rating.toLocaleString(this.getLocale, {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    height: 24px;
    margin-left: -3px; /* counter margin-left of first star in the star rating */

    > div {
        @apply whitespace-nowrap relative w-[150px];

        .star-ratings-full {
            @apply text-yellow-300 top-0 absolute overflow-hidden;
        }

        .star-ratings-empty {
            @apply text-slate-300;
        }

        .icon {
            width: 24px;
            height: 24px;
            margin: 0 3px;
            vertical-align: middle;
        }
    }

    > span {
        height: 100%;
        @apply text-sm ml-3 leading-6;
    }

    &.rating-size-small {
        height: 20px;

        > div {
            width: 130px;

            .icon {
                width: 20px;
                height: 20px;
            }
        }

        > span {
            @apply text-xs ml-1 leading-5;
        }
    }

    @media (max-width: 345px) {
        .rate {
            @apply hidden;
        }
    }
}
</style>
